import PropTypes from "prop-types";
import React from "react";
import Select from "react-select";

const MultiSelect = ({
  field,
  form,
  options,
  disableStatus,
  isMulti = false,
  placeholder = 'Please Select',
  onChangeFunction = false,
  setOnChange,
  isForQueryBuilder = false,
  values,
  otherValue = false,
  multiSelectStyles,
  defaultValue
}) => {

  const selectStyle = multiSelectStyles ? {styles: multiSelectStyles} : {}
  
  function onChange(option) {
    if(isMulti)
    {
      form.setFieldValue(
        field.name,
        option ? (option).map((item) => item.value) : [],
      );
    }
    else
    {
      form.setFieldValue(field.name, option.value)
    }
    
    if (setOnChange)
      setOnChange(option);
  }

  const getValue = (defaultValue) => {
    if(!isMulti)
    options.unshift({label: "Please Select" , value: ""});
    let foundValue;
    if (options) {
      foundValue=  isMulti
        ? options.filter((option) => field.value.indexOf(option.value) >= 0)
        : options.find(option => option.value === field.value);
    } else {
      foundValue= isMulti ? [] : ('');
    }
    
    if(foundValue === undefined)
      foundValue = {value: '', label:defaultValue}

    return foundValue;
  };

  function onQueryBuilderChange(option) {
    form.setFieldValue(
      field.name,
      option ? (option).map((item) => item.value) : [],
    );

    if (setOnChange)
      setOnChange(option);
  }

  const getQueryBuilderValue = () => {
    if (options) {
      if (!field.value)
        field.value = isMulti ? [] : ('');

      if (values || values === "") {
        field.value = values;
      }

      return isMulti
        ? options.filter((option) => field.value.indexOf(option.value) >= 0)
        : options.find((option) => option.value === field.value);
    } else {
      return isMulti ? [] : ('');
    }
  };

  if (onChangeFunction && !isMulti && !otherValue) {
    return (
      <Select
        options={options}
        name={field.name}
        isDisabled={disableStatus}
        value={getValue(defaultValue)}
        onChange={onChange}
        onBlur={field.onBlur}
        placeholder={placeholder}
        //classNamePrefix="react-select"
        {...(selectStyle)}
      />
    )
  }
  if (!isMulti&&!otherValue) {
    return (
      <Select
        options={options}
        name={field.name}
        value={getValue(defaultValue)}
        onChange={onChange}
        onBlur={field.onBlur}
        isDisabled={disableStatus}
        placeholder={placeholder}
        {...(selectStyle)}
      />
    )
  } else if (isForQueryBuilder) {
    return (
      <Select
        className="react-select"
        name={field.name}
        value={getQueryBuilderValue()}
        onChange={onQueryBuilderChange}
        options={options}
        isDisabled={disableStatus}
        isMulti={true}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        {...(selectStyle)}
      />
    )
  } else if (otherValue && onChangeFunction) {
    if(options.find(option=>option.value != "-1"))
    options.push({label:"Other",value:"-1"})
    return (
      <Select
        options={options}
        name={field.name}
        value={options ? options.find(option => option.value === field.value) : ''}
        onChange={option => { setOnChange(option); form.setFieldValue(field.name, option.value) }}
        onBlur={field.onBlur}
        isDisabled={disableStatus}
        placeholder={placeholder}
      />
    )
  }
  else {
    return (
      <Select
        className="react-select"
        name={field.name}
        value={getValue(defaultValue)}
        onChange={onChange}
        options={options}
        isDisabled={disableStatus}
        isMulti={true}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        {...(selectStyle)}
      />
    )
  }
}

MultiSelect.propTypes = {
  field: PropTypes.any,
  form: PropTypes.any,
  options: PropTypes.any,
  isMulti: PropTypes.any,
  placeholder: PropTypes.any,
  disableStatus: PropTypes.bool,
  deneme: PropTypes.any,
  onChangeFunction: PropTypes.any,
  setOnChange: PropTypes.any,
  isForQueryBuilder: PropTypes.bool,
  values: PropTypes.any,
  otherValue: PropTypes.any,
  multiSelectStyles: PropTypes.object,
  defaultValue:PropTypes.any
};

export default MultiSelect;
